import React from 'react'
import {
    unstable_useControl as useControl,
    type FieldMetadata,
} from '@conform-to/react'
import { useRef, type ElementRef, ComponentProps } from 'react'
import {
    SelectTrigger,
    Select,
    SelectValue,
    SelectContent,
    SelectItem,
} from '~/components/ui/select'
import { ScrollArea } from '~/components/ui/scroll-area'

interface SelectConformProps {
    meta: FieldMetadata<string | number>
    items: Array<{ name: string; value: string }>
    placeholder?: string
    initialValue?: string
    dependency?: boolean
    handleChange?: (value?: string) => void
}

export const SelectConform = ({
    meta,
    items,
    placeholder,
    handleChange,
    initialValue,
    dependency,
    ...props
}: SelectConformProps & ComponentProps<typeof Select>) => {
    const selectRef = useRef<ElementRef<typeof SelectTrigger>>(null)
    const control = useControl(meta)
      const [align, setAlign] = React.useState<'center' | 'start'>('start');
    

    React.useEffect(() => {
        //when dependency is false then clear autofill
        if (dependency === true && initialValue) {
            control.change(initialValue)
        } else if (dependency === false) {
            control.change('')
        }
    }, [dependency, initialValue])

   
        React.useEffect(() => {
            setAlign(window.innerWidth <= 600 ? 'center' : 'start');
        }, []);
    

    return (
        <>
            <select
                name={meta.name}
                className='sr-only'
                ref={control.register}
                aria-hidden
                tabIndex={-1}
                onFocus={() => {
                    selectRef.current?.focus()
                }}
                id={meta.id}
            >
                <option value='' />
                {items.map((option) => (
                    <option key={option.value} value={option.value} />
                ))}
            </select>

            <Select
                {...props}
                value={control.value ?? ''}
                onValueChange={(value) => {
                    control.change(value)

                    if (handleChange) {
                        handleChange(value)
                    }
                }}
                onOpenChange={(open) => {
                    if (!open) {
                        control.blur()
                    }
                }}
            >
                <SelectTrigger className='text-left'>
                    <SelectValue
                        placeholder={placeholder ?? 'Select an option'}
                    />
                </SelectTrigger>
                <SelectContent
                    side='bottom'
                    align={align}
                    className='max-w-[80vw] sm:max-w-full'
                >
                    <ScrollArea>
                        {items.map((item) => {
                            return (
                                <SelectItem key={item.value} value={item.value}>
                                    {item.name}
                                </SelectItem>
                            )
                        })}
                    </ScrollArea>
                </SelectContent>
            </Select>
        </>
    )
}
